import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./rewardsHome.scss";
import { rewardsService } from "../../services/rewards.service";

export const RewardsHome = () => {
  const [rewardProducts, setRewardProducts] = useState([]);

  useEffect(() => {
    rewardsService.LatestRewardProducts(0).then((result) => {
      setRewardProducts(result.items);
    });
  }, []);

  return (
    <section className="wrapper__rewards__home">
      <div className="container_rewards__home">
        <div className="sec_rewards_ttl">
          <h2 className=" font_ttl_in_home">Rewards</h2>
          <p className="">Acumula puntos y canjéalos por regalos exclusivos</p>

          {rewardProducts.length === 0 ? (
            ""
          ) : (
            <div className="flex-center">
              <Link to="/rewards" className="link_btn_home">
                <span>Ver más</span>
              </Link>
            </div>
          )}
        </div>

        <div className="sec_items_rewards">
          {rewardProducts.length === 0
            ? "No hay recompensas disponibles"
            : rewardProducts.map((item,i) => (
                <div className="item_reward" key={i}>
                  <img src={item.urlImage} alt={item.title} />
                  <p className="text fnt_medium mt-3">{item.title}</p>
                </div>
              ))}
        </div>
      </div>
    </section>
  );
};
